<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    class="large-text-container"
    :class="[cms.align === 'left' ? 'left-align' : 'right-align']"
    :style="mainCssVars"
  >
    <grid class="grid--container">
      <grid-item
        v-if="cms.enableBackButton"
        :layout="[{ size: 1, x: 1, width: 12 }]"
      >
        <a class="back-button" href="/en-gb/our-work/"
          ><img
            src="https://a.storyblok.com/f/46530/16x10/07d3142480/vector.png"
            alt="back-arrow"
          />
          Back to all work</a
        >
      </grid-item>
      <grid-item
        class="left-text"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 2, x: 1, width: 6 },
        ]"
      >
        <div v-html="cms.leftText" />
      </grid-item>
      <grid-item
        class="right-text"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 2, x: 7, width: 6 },
        ]"
        v-html="cms.rightText"
      />
    </grid>
    <grid v-if="cms.leftTextTwo" class="grid--container secondary-row">
      <grid-item
        class="left-text-small"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 2, x: 1, width: 6 },
        ]"
      >
        <div class="left-text-secondary">{{ cms.leftTextTwo }}</div>
      </grid-item>
      <grid-item
        class="right-text-small"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 2, x: 7, width: 6 },
        ]"
      >
        <div class="right-text-secondary">
          <div
            v-for="(pill, index) in splittedPills"
            :key="index"
            class="right-text-secondary-pill"
          >
            {{ pill }}
          </div>
        </div>
      </grid-item>
    </grid>
  </div>
</template>
<script>
import Colors from '~/mixins/colors'
export default {
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        return {}
      },
    },
  },

  data() {
    return {
      leftText: '',
      rightText: '',
    }
  },

  computed: {
    mainCssVars() {
      return {
        '--bg-color': this.cms.backgroundColor || 'black',
        '--text-color': this.cms.fontColor || 'white',
        '--main-padding-top': this.cms.enableBackButton ? '0px' : '190px',
      }
    },
    splittedPills() {
      // Split the string by commas into an array
      return this.cms.rightTextPills ? this.cms.rightTextPills.split(',') : ''
    },
  },
}
</script>
<style lang="scss" scoped>
.back-button {
  display: flex;
  margin-top: 80px;
  margin-bottom: 80px;
  align-items: center;
  gap: 16px;
  img {
    width: 16px;
    height: 10px;
  }
}

.large-text-container {
  width: 100%;
  padding-top: var(--main-padding-top);
  background: var(--bg-color);
  border-color: var(--text-color);
}

.secondary-row {
  margin-top: 60px;
  padding-bottom: 30px;
}

.left-text {
  font-family: 'Druk', Helvetica, Arial, sans-serif;
  font-size: 120px;
  font-style: normal;
  font-weight: 500;
  line-height: 80%; /* 96px */
  letter-spacing: 1.2px;
  text-transform: uppercase;
}

@media screen and (max-width: 767px) {
  .left-text {
    font-size: 64px;
  }
}

.left-text-small {
  display: grid;
  align-items: end;
}

.left-text-secondary {
  color: #161a1d;

  /* S - 16/Bold */
  font-family: 'NeueHaasGroteskText', Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 125%; /* 20px */
}

.right-text {
  font-family: 'NeueHaasGroteskText', Helvetica, Arial, sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%; /* 35px */
}

.right-text-secondary {
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  gap: 10px;
  flex: 1 0 0;
  flex-wrap: wrap;
}

.right-text-secondary-pill {
  display: flex;
  padding: 10px 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 22px;
  border: 1px solid #2b353b;
  font-family: 'NeueHaasGroteskText', Helvetica, Arial, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 15px;
}

@media only screen and (max-width: 600px) {
  .large-text-container {
    width: 100%;
    padding-top: 80px;
  }

  .right-text {
    font-size: 20px;
  }

  .left-text {
    margin-bottom: 64px;
  }

  .left-text-secondary {
    margin-bottom: 32px;
  }
}
</style>
